import legal from "../../../assets/CampuLifeImages/legal.jpg"
import ExtenStudClubGrievPage from '../../CampusSharedComponent/CampusDynamicPages/CampusExtenStudClubGrievDynamicPage/ExtenStudClubGrievPage'




const LegalAID = () => {
  
   const data = 
    { 
      name:"legal",
      hover:true,
      viewmore:true,
      viewless:true,
      pagename: "Legal AID Club",
      title: "Legal AID Club Activities",
      contentImg:legal,
      para:"The Legal Aid Club in Noorul Islam College of Arts and Science, aims to promote legal awareness, to provide basic legal assistance, to create awareness and educate the different sections of society about the various legislation, rules, and regulations and empower students and the community with knowledge about their rights and responsibilities. Its key objectives include:",
      arrayList:[
        {title:"Spreading Legal Awareness : ",content:["Educating students and the local community about their legal rights and duties.","Conducting seminars, workshops, and awareness campaigns."]},
        {title:"Providing Free Legal Aid : ",content:["Assisting underprivileged individuals by offering free legal guidance.","Collaborating with legal professionals to provide counseling."]},
        {title:"Promoting Access to Justice : ",content:["Helping people understand and access legal procedures.","Supporting marginalized sections by bridging the gap between them and the legal system."]},
        {title:"Skill Development for Students : ",content:["Enhancing students' legal knowledge and advocacy skills.","Encouraging participation in moot courts, legal debates, and legal literacy camps."]},
        {title:"Collaboration with Legal Authorities : ",content:["Partnering with District Legal Services Authorities (DLSA) or other legal bodies.","Organizing visits to courts, legal aid centers, and public offices."]},
        {title:"Upholding Social Justice:",content:["Promoting social justice by raising awareness about issues like gender equality, human rights, and environmental law.","Supporting initiatives that fight against injustice and discrimination."]},
      ],
      fourhover:true
    }
   
   const hoverContent =[
     {  img: legal, para1: "Independence Day Celebration", para2: "March 14, 2024" },
     {  img: legal, para1: "Independence Day Celebration", para2: "March 14, 2024" },
     {  img: legal, para1: "Independence Day Celebration", para2: "March 14, 2024" },
     {  img: legal, para1: "Independence Day Celebration", para2: "March 14, 2024" }
 ]
  return (
    <>
     <ExtenStudClubGrievPage data = {data} hoverContent = {hoverContent} />
    </>
   
  )
}

export default LegalAID
